// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Footer container */
.footer-bottom {
  color: #0a0101;
  padding: 20px;
  text-align: center;
  
}

/* Social media icons */
.social-media {
  margin-bottom: 20px;
}

.social-icon {
  display: inline-block;
  margin: 0 10px;
  color: #070101;
  font-size: 20px;
  text-decoration: none;
  margin-inline: 20px;
}

/* Footer menu */
.footer-menu {
  margin-bottom: 20px;
}

.f-menu {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.f-menu li {
  display: inline-block;
  margin-inline: 30px;
  margin-right: 10px;
  font-size: larger;
}

.f-menu li a {
  font-size: 20px;
  color: #000000;
  text-decoration: none;
  transition: color 0.3s ease;

}

.f-menu li a:hover {
  color: #14db02;
  transition: color 0.3s ease;
}

.social-icon:hover {
  display: inline-block;
  margin-inline: 20px;
  color: #f10101;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.3s ease;
}

/* Animation */
@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(50px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Mobile responsive */
@media screen and (max-width: 768px) {
  .footer {
    padding: 10px;
  }

  .social-icon {
    font-size: 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/FrontEnd/Footer/Footer.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;;AAEpB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,2BAA2B;;AAE7B;;AAEA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,2BAA2B;AAC7B;;AAEA,cAAc;AACd;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Footer container */\n.footer-bottom {\n  color: #0a0101;\n  padding: 20px;\n  text-align: center;\n  \n}\n\n/* Social media icons */\n.social-media {\n  margin-bottom: 20px;\n}\n\n.social-icon {\n  display: inline-block;\n  margin: 0 10px;\n  color: #070101;\n  font-size: 20px;\n  text-decoration: none;\n  margin-inline: 20px;\n}\n\n/* Footer menu */\n.footer-menu {\n  margin-bottom: 20px;\n}\n\n.f-menu {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n\n.f-menu li {\n  display: inline-block;\n  margin-inline: 30px;\n  margin-right: 10px;\n  font-size: larger;\n}\n\n.f-menu li a {\n  font-size: 20px;\n  color: #000000;\n  text-decoration: none;\n  transition: color 0.3s ease;\n\n}\n\n.f-menu li a:hover {\n  color: #14db02;\n  transition: color 0.3s ease;\n}\n\n.social-icon:hover {\n  display: inline-block;\n  margin-inline: 20px;\n  color: #f10101;\n  text-decoration: none;\n  cursor: pointer;\n  transition: color 0.3s ease;\n}\n\n/* Animation */\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(50px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Mobile responsive */\n@media screen and (max-width: 768px) {\n  .footer {\n    padding: 10px;\n  }\n\n  .social-icon {\n    font-size: 15px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
